import addScript from '../../services/script-loader';

const SEARCH_PAGE_OPTIONS = window.Site?.adSenseConfig;

const configureSearchPageSlot = ($element, query) => {
  if (!SEARCH_PAGE_OPTIONS) {
    return;
  }
  const pageOptions = { ...SEARCH_PAGE_OPTIONS, query };
  const adBlockElement = {
    container: $element.getAttribute(`id`),
  };

  window._googCsa(`ads`, pageOptions, adBlockElement);
};

const configureContentPageSlot = ($element) => {
  if (!SEARCH_PAGE_OPTIONS) {
    return;
  }

  // eslint-disable-next-line
  const { adsafe, ...generalParams } = SEARCH_PAGE_OPTIONS;
  const params = {
    ...generalParams,
    relatedSearchTargeting: `content`,
  };

  const relatedSearchBlock = {
    container: $element.getAttribute(`id`),
    relatedSearches: 3,
  };

  window._googCsa(`relatedsearch`, params, relatedSearchBlock);
};

/* eslint-disable */
const initGoogleAdSenseSearchScript = () => {
  (function (g, o) {
    (g[o] =
      g[o] ||
      function () {
        (g[o][`q`] = g[o][`q`] || []).push(arguments);
      })((g[o][`t`] = 1 * new Date()));
  })(window, `_googCsa`);
};
/* eslint-enable */

const initGoogleAdSenseSearchSDK = async () =>
  new Promise((resolve) => {
    if (!window._googCsa) {
      addScript(`https://www.google.com/adsense/search/ads.js`, () => {
        initGoogleAdSenseSearchScript();
        resolve();
      });
    } else {
      resolve();
    }
  });

const initRelativeContentSlot = ($elementsList = []) => {
  $elementsList.forEach(($element) =>
    initGoogleAdSenseSearchSDK().then(() => configureContentPageSlot($element)),
  );
};

const initSearchPageSlot = ($element, query = ``) => {
  if (!$element) {
    return;
  }
  initGoogleAdSenseSearchSDK().then(() => configureSearchPageSlot($element, query));
};

export { initRelativeContentSlot, initSearchPageSlot };
